$('.winner-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');
    $('section#winner .page').addClass('d-none');

    $('#winner-result').removeClass('d-none')
});

$('.winner-form').on('submit-error', function(event, xhr) {
    event.preventDefault();
    if (xhr.status == 410) {
        location.reload();
    }
});
